export const commonEN = {
  // Navigation
  'nav.manifesto': 'Manifesto',
  'nav.services': 'Services',
  'nav.industries': 'Industries',
  'nav.contact': 'Contact',
  'nav.cta': 'Start AI Value Discovery',

  // Loading
  'loading': 'Loading...',

  // Footer
  'footer.tagline1': 'Boutique Data & AI transformation consultancy.',
  'footer.tagline2': 'We turn data and AI into measurable business results — not experiments.',
  'footer.colSite': 'Site',
  'footer.colMethodology': 'Methodology',
  'footer.colIndustries': 'Industries',
  'footer.colContact': 'Contact',
  'footer.linkHome': 'Home',
  'footer.linkManifesto': 'Manifesto',
  'footer.linkServices': 'Services',
  'footer.linkIndustries': 'Industries',
  'footer.linkContact': 'Contact',
  'footer.linkDiscovery': 'AI Value Discovery',
  'footer.linkIndustrialization': 'AI Industrialization',
  'footer.linkAccelerators': 'Accelerators',
  'footer.linkEngagement': 'Engagement Model',
  'footer.indRetail': 'Retail & E-commerce',
  'footer.indFinancial': 'Financial Services',
  'footer.indLogistics': 'Logistics & Supply Chain',
  'footer.indManufacturing': 'Manufacturing',
  'footer.indHealthcare': 'Healthcare',
  'footer.indB2B': 'B2B / SaaS',
  'footer.indStartups': 'Startups & Scale-ups',
  'footer.cta': 'Start AI Value Discovery →',
  'footer.systemName': 'PERCEPTYA AI VALUE SYSTEM™',
  'footer.methodTag1': 'AI Value Discovery',
  'footer.methodTag2': 'AI Maturity Score™',
  'footer.methodTag3': 'Use Case Prioritization',
  'footer.methodTag4': 'Architecture Blueprint',
  'footer.methodTag5': 'Financial Impact Model',
  'footer.methodTag6': 'AI Industrialization',
  'footer.methodTag7': 'Agent Architecture',
  'footer.methodTag8': 'ROI & Value Tracking',
  'footer.copyright': '© {year} Perceptya. All rights reserved.',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms of Service',
  'footer.locale': 'São Paulo · Remote Global',

  // Newsletter
  'newsletter.label': 'STAY AHEAD',
  'newsletter.headline': 'AI insights that move the needle.',
  'newsletter.sub': 'Frameworks, case studies, and strategies used by the companies actually shipping AI to production. No fluff.',
  'newsletter.placeholder': 'your@email.com',
  'newsletter.cta': 'Subscribe',
  'newsletter.submitting': 'Subscribing...',
  'newsletter.success': "You\u2019re in. Check your inbox to confirm.",
  'newsletter.privacy': 'No spam. Unsubscribe anytime.',

  // Shared CTA texts used across multiple pages
  'cta.startDiscovery': 'Start AI Value Discovery',
  'cta.readManifesto': 'Read our Manifesto',
  'cta.exploreMethodology': 'Explore our methodology',
  'cta.seeMethodology': 'See our methodology',
  'cta.nextStep': 'Next Step',
  'cta.startHere': 'Start Here',
  'cta.readyHeadline': 'Ready to find out where AI creates {em}real value{/em} for your business?',
  'cta.readySub': 'The AI Value Discovery is the starting point. 6–10 weeks. Executive clarity. A clear plan backed by economic modeling.',
} as const;

export const commonPT = {
  // Navigation
  'nav.manifesto': 'Manifesto',
  'nav.services': 'Serviços',
  'nav.industries': 'Indústrias',
  'nav.contact': 'Contato',
  'nav.cta': 'Iniciar AI Value Discovery',

  // Loading
  'loading': 'Carregando...',

  // Footer
  'footer.tagline1': 'Consultoria boutique de transformação em Data & AI.',
  'footer.tagline2': 'Transformamos dados e IA em resultados de negócio mensuráveis — não experimentos.',
  'footer.colSite': 'Site',
  'footer.colMethodology': 'Metodologia',
  'footer.colIndustries': 'Indústrias',
  'footer.colContact': 'Contato',
  'footer.linkHome': 'Início',
  'footer.linkManifesto': 'Manifesto',
  'footer.linkServices': 'Serviços',
  'footer.linkIndustries': 'Indústrias',
  'footer.linkContact': 'Contato',
  'footer.linkDiscovery': 'AI Value Discovery',
  'footer.linkIndustrialization': 'Industrialização de IA',
  'footer.linkAccelerators': 'Aceleradores',
  'footer.linkEngagement': 'Modelo de Engajamento',
  'footer.indRetail': 'Varejo & E-commerce',
  'footer.indFinancial': 'Serviços Financeiros',
  'footer.indLogistics': 'Logística & Supply Chain',
  'footer.indManufacturing': 'Manufatura',
  'footer.indHealthcare': 'Saúde',
  'footer.indB2B': 'B2B / SaaS',
  'footer.indStartups': 'Startups & Scale-ups',
  'footer.cta': 'Iniciar AI Value Discovery →',
  'footer.systemName': 'PERCEPTYA AI VALUE SYSTEM™',
  'footer.methodTag1': 'AI Value Discovery',
  'footer.methodTag2': 'AI Maturity Score™',
  'footer.methodTag3': 'Priorização de Use Cases',
  'footer.methodTag4': 'Architecture Blueprint',
  'footer.methodTag5': 'Financial Impact Model',
  'footer.methodTag6': 'Industrialização de IA',
  'footer.methodTag7': 'Agent Architecture',
  'footer.methodTag8': 'ROI & Value Tracking',
  'footer.copyright': '© {year} Perceptya. Todos os direitos reservados.',
  'footer.privacy': 'Política de Privacidade',
  'footer.terms': 'Termos de Serviço',
  'footer.locale': 'São Paulo · Remoto Global',

  // Newsletter
  'newsletter.label': 'SAIA NA FRENTE',
  'newsletter.headline': 'Insights de AI que movem o ponteiro.',
  'newsletter.sub': 'Frameworks, cases e estratégias usados por empresas que realmente colocam AI em produção. Sem enrolação.',
  'newsletter.placeholder': 'seu@email.com',
  'newsletter.cta': 'Assinar',
  'newsletter.submitting': 'Assinando...',
  'newsletter.success': 'Feito. Confira sua caixa de entrada para confirmar.',
  'newsletter.privacy': 'Sem spam. Cancele quando quiser.',

  // Shared CTA texts used across multiple pages
  'cta.startDiscovery': 'Iniciar AI Value Discovery',
  'cta.readManifesto': 'Leia nosso Manifesto',
  'cta.exploreMethodology': 'Explore nossa metodologia',
  'cta.seeMethodology': 'Veja nossa metodologia',
  'cta.nextStep': 'Próximo Passo',
  'cta.startHere': 'Comece Aqui',
  'cta.readyHeadline': 'Pronto para descobrir onde a IA gera {em}valor real{/em} para o seu negócio?',
  'cta.readySub': 'O AI Value Discovery é o ponto de partida. 6–10 semanas. Clareza executiva. Um plano claro respaldado por modelagem econômica.',
} as const;

export const commonES = {
  // Navigation
  'nav.manifesto': 'Manifiesto',
  'nav.services': 'Servicios',
  'nav.industries': 'Industrias',
  'nav.contact': 'Contacto',
  'nav.cta': 'Iniciar AI Value Discovery',

  // Loading
  'loading': 'Cargando...',

  // Footer
  'footer.tagline1': 'Consultoría boutique de transformación en Data & AI.',
  'footer.tagline2': 'Transformamos datos e IA en resultados de negocio medibles — no experimentos.',
  'footer.colSite': 'Sitio',
  'footer.colMethodology': 'Metodología',
  'footer.colIndustries': 'Industrias',
  'footer.colContact': 'Contacto',
  'footer.linkHome': 'Inicio',
  'footer.linkManifesto': 'Manifiesto',
  'footer.linkServices': 'Servicios',
  'footer.linkIndustries': 'Industrias',
  'footer.linkContact': 'Contacto',
  'footer.linkDiscovery': 'AI Value Discovery',
  'footer.linkIndustrialization': 'Industrialización de IA',
  'footer.linkAccelerators': 'Aceleradores',
  'footer.linkEngagement': 'Modelo de Compromiso',
  'footer.indRetail': 'Retail & E-commerce',
  'footer.indFinancial': 'Servicios Financieros',
  'footer.indLogistics': 'Logística & Cadena de Suministro',
  'footer.indManufacturing': 'Manufactura',
  'footer.indHealthcare': 'Salud',
  'footer.indB2B': 'B2B / SaaS',
  'footer.indStartups': 'Startups & Scale-ups',
  'footer.cta': 'Iniciar AI Value Discovery →',
  'footer.systemName': 'PERCEPTYA AI VALUE SYSTEM™',
  'footer.methodTag1': 'AI Value Discovery',
  'footer.methodTag2': 'AI Maturity Score™',
  'footer.methodTag3': 'Priorización de Casos de Uso',
  'footer.methodTag4': 'Architecture Blueprint',
  'footer.methodTag5': 'Financial Impact Model',
  'footer.methodTag6': 'Industrialización de IA',
  'footer.methodTag7': 'Agent Architecture',
  'footer.methodTag8': 'ROI & Value Tracking',
  'footer.copyright': '© {year} Perceptya. Todos los derechos reservados.',
  'footer.privacy': 'Política de Privacidad',
  'footer.terms': 'Términos de Servicio',
  'footer.locale': 'São Paulo · Remoto Global',

  // Newsletter
  'newsletter.label': 'ADELÁNTESE',
  'newsletter.headline': 'Insights de AI que mueven la aguja.',
  'newsletter.sub': 'Frameworks, casos y estrategias usados por empresas que realmente llevan AI a producción. Sin relleno.',
  'newsletter.placeholder': 'su@email.com',
  'newsletter.cta': 'Suscribirse',
  'newsletter.submitting': 'Suscribiendo...',
  'newsletter.success': 'Listo. Revise su bandeja para confirmar.',
  'newsletter.privacy': 'Sin spam. Cancele cuando quiera.',

  // Shared CTA texts used across multiple pages
  'cta.startDiscovery': 'Iniciar AI Value Discovery',
  'cta.readManifesto': 'Lee nuestro Manifiesto',
  'cta.exploreMethodology': 'Explora nuestra metodología',
  'cta.seeMethodology': 'Ver nuestra metodología',
  'cta.nextStep': 'Siguiente Paso',
  'cta.startHere': 'Comience Aquí',
  'cta.readyHeadline': '¿Listo para descubrir dónde la IA genera {em}valor real{/em} para su negocio?',
  'cta.readySub': 'El AI Value Discovery es el punto de partida. 6–10 semanas. Claridad ejecutiva. Un plan claro respaldado por modelado económico.',
} as const;
